import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ba066bf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "PopupHeadline px-3 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = { class: "h5-responsive strong p-0 m-0 d-inline-block" };
const _hoisted_3 = {
    key: 0,
    class: "d-inline-block"
};
const _hoisted_4 = {
    key: 0,
    src: "/images/_new_brand/icons/icon_success.svg",
    class: "icon",
    alt: "OK"
};
const _hoisted_5 = {
    key: 1,
    src: "/images/_new_brand/icons/icon_warning.svg",
    class: "icon",
    alt: "!"
};
const _hoisted_6 = {
    key: 2,
    src: "/images/_new_brand/icons/icon_error.svg",
    class: "icon",
    alt: "X"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
    key: 0,
    class: "row px-sm-5 px-3 pb-sm-5 pb-3"
};
const _hoisted_10 = { class: "col-sm-6 col-12 mb-sm-0 mb-3" };
const _hoisted_11 = { class: "col-sm-6 col-12" };
import eventBus from '@/services/EventBus';
import { ref, onMounted } from 'vue';
// POPUP WIRD SO GEÖFFNET (Das Icon kann 'error', 'success', 'warning' oder 'info' sein.):
// (Buttons und dessen Functions, icons und persistant sind optional),
// eventBus.emit('openInfoPopup', {
//     icon: 'success',
//     headline: 'Ich bin die Headline',
//     message: 'Ich bin die Nachricht! (Sollte auch immer mit angegeben werden, ..Optik)'
//     persistent: true,
//     buttonConfirmText : 'Ab geht's',
//     buttonConfirmFunction: confirmFunction,
//     buttonDenyText : 'Nö!',
//     buttonDenyFunction: denyFunction,
// const confirmFunction = () => {
//     eventBus.emit('closeInfoPopup');
//     console.log('Uwe ist da!');
// }
// const denyFunction = () => {
//     eventBus.emit('closeInfoPopup');
//     console.log('Uwe ist weg!');
// }
export default /*#__PURE__*/ _defineComponent({
    __name: 'InfoPopup',
    setup(__props) {
        let infoData;
        onMounted(() => {
            eventBus.on('openInfoPopup', responseData);
            eventBus.on('closeInfoPopup', closePopup);
        });
        const openPopup = ref(false);
        function responseData(data) {
            infoData = data;
            openPopup.value = true;
            if (infoData.timer !== undefined) {
                setTimeout(() => {
                    eventBus.emit('closeInfoPopup');
                }, infoData.timer);
            }
        }
        function closePopup() {
            openPopup.value = false;
        }
        return (_ctx, _cache) => {
            var _a, _b;
                                                                  
                                                                      
            return (_openBlock(), _createBlock(_component_v_dialog, {
                persistent: (_b = (_a = _unref(infoData)) === null || _a === void 0 ? void 0 : _a.persistent) !== null && _b !== void 0 ? _b : false,
                class: "infoPopup",
                modelValue: openPopup.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((openPopup).value = $event)),
                width: "500",
                "max-height": "80vh"
            }, {
                default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("span", _hoisted_2, [
                                    (_unref(infoData).icon === 'info' ||
                                        _unref(infoData).icon === 'success' ||
                                        _unref(infoData).icon === 'warning' ||
                                        _unref(infoData).icon === 'error')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                            (_unref(infoData).icon === 'success' || _unref(infoData).icon === 'info')
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                                                : _createCommentVNode("", true),
                                            (_unref(infoData).icon === 'warning')
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                                : _createCommentVNode("", true),
                                            (_unref(infoData).icon === 'error')
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_unref(infoData).headline), 1)
                                ]),
                                (!_unref(infoData).persistent || !(_unref(infoData).buttonDenyFunction || _unref(infoData).buttonConfirmFunction))
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        onClick: ($event) => (isActive.value = false),
                                        class: "icon-cancel pointerhover float-right pr-2"
                                    }, null, 8, _hoisted_7))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                                class: "p-sm-5 p-3 font5-responsive",
                                innerHTML: _unref(infoData).message
                            }, null, 8, _hoisted_8),
                            (_unref(infoData).buttonConfirmText || _unref(infoData).buttonDenyText)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        (_unref(infoData).buttonDenyText)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[0] || (_cache[0] =
                                                    //@ts-ignore
                                                    (...args) => (_unref(infoData).buttonDenyFunction && _unref(infoData).buttonDenyFunction(...args))),
                                                class: "[ cy_btn_deny ] buttonBase buttonBlue w-100",
                                                type: "button"
                                            }, _toDisplayString(_unref(infoData).buttonDenyText), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        (_unref(infoData).buttonConfirmText)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[1] || (_cache[1] =
                                                    //@ts-ignore
                                                    (...args) => (_unref(infoData).buttonConfirmFunction && _unref(infoData).buttonConfirmFunction(...args))),
                                                class: "buttonBase buttonGreen w-100",
                                                type: "button"
                                            }, _toDisplayString(_unref(infoData).buttonConfirmText), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["persistent", "modelValue"]));
        };
    }
});


/* Vuetify */
import { VCard as _component_v_card } from "vuetify/lib/components/VCard/index.mjs"
import { VDialog as _component_v_dialog } from "vuetify/lib/components/VDialog/index.mjs"

